import React from 'react';
import Card from '@material-ui/core/Card/Card';

// todo: marginBottom could be parameter
export const MCard = ({children, style, onClick}) => (
    <div style={style} onClick={onClick}>
        <Card raised={true}>{children}</Card>
    </div>
);